export const LOCALE_OPTIONS = [
  { value: 'en', labelKey: 'locale.english', flag: 'us' },
  { value: 'id', labelKey: 'locale.indonesian', flag: 'id' },
]

export function getLocaleOption(locale) {
  return LOCALE_OPTIONS.find((item) => item.value === locale) || LOCALE_OPTIONS[0]
}

export function localeFlagClass(locale) {
  return `flag-icon-${getLocaleOption(locale).flag}`
}
